// 封装桥能力的函数，暴露给业务

// 通知native下载文件
export const jsBridgeDownloadPromise = (url) => {
  return new Promise((resolve, reject) => {
    try {
      console.log('downloadFile', url)
      window.flutter_inappwebview.callHandler('downloadFile', { url });
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};
// 通知native关闭弹窗
export const jsBridgeCloseDialogPromise = (params = {}) => {
  return new Promise((resolve, reject) => {
    try {
      window.flutter_inappwebview.callHandler('closeDialog');
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};
// 通知native-问卷提交成功-点击我已知道
export const jsBridgeIknowPromise = (params = {}) => {
  return new Promise((resolve, reject) => {
    try {
      window.flutter_inappwebview.callHandler('callDirectionalMethod');
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

// 通知native-开启位置信息
export const jsBridgeStartLocationPromise = (params = {}) => {
  return new Promise((resolve, reject) => {
    try {
      window.flutter_inappwebview.callHandler('startLocation').then(res => {
        // latitude    longitude
        resolve(res);
      });
    } catch (error) {
      reject(error);
    }
  });
};

// 从native获取是否已开启位置权限
export const jsBridgeCheckLocationPromise = (params = {}) => {
  return new Promise((resolve, reject) => {
    try {
      window.flutter_inappwebview?.callHandler('checkLocationPermission').then(res => {
        resolve(res);
      });
    } catch (error) {
      reject(error);
    }
  });
};

// 通知native-扫描标签二维码
export const jsBridgeScanCodePromise = (params = {}) => {
  return new Promise((resolve, reject) => {
    try {
      window.flutter_inappwebview.callHandler('scanCode').then(res => {
        resolve(res);
      });
    } catch (error) {
      reject(error);
    }
  });
};